<template>
  <tbody>
    <tr class="text-xs-center hovereable" v-for="(item, i) in items" :key="i" @click="editItemWithEvent($event, item.id)">
      <td width="120">
        <v-icon x-large class="k-orange-linear-text text--darken-2" v-if="item.channel === 'email'">fas fa-envelope</v-icon>
        <v-icon x-large class="k-orange-linear-text text--darken-2" v-if="item.channel === 'whatsapp'">fab fa-whatsapp</v-icon>
        <v-icon x-large class="k-orange-linear-text text--darken-2" v-if="item.channel === 'facebook'">fab fa-facebook-messenger</v-icon>
        <v-icon x-large class="k-orange-linear-text text--darken-2" v-if="item.channel === 'telegram'">fab fa-telegram</v-icon>
        <v-icon x-large class="k-orange-linear-text text--darken-2" v-if="item.channel === 'sms'">fab fa-comment</v-icon>
      </td>
      <td class="text-xs-left">
        {{ item.name }}
        <small>
          <template v-if="item.channel !== 'email'">
            <div class="word-wrap">
              {{ item.text }}
            </div>
          </template>
        </small>
      </td>
      <td class="text-xs-right">
        <v-chip medium class="green white--text" v-if="item.status === 'activo'">
          <v-icon class="pr-2 white--text" small>fas fa-check</v-icon>
          Activo
        </v-chip>
        <v-chip medium class="grey darken-0 white--text" v-if="item.status === 'inactivo'">
          <v-icon class="pr-2 white--text" small>fas fa-user-slash</v-icon>
          Inactivo
        </v-chip>
      </td>
      <td class="text-xs-right">
        <v-menu left offset-x>
          <v-btn color="black" icon flat slot="activator">
            <v-icon small>fas fa-ellipsis-v</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="editItemWithEvent($event, item.id)">
              <v-list-tile-title>
                Editar
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="changeStatus(item, item.status)">
              <v-list-tile-title>
                <template v-if="item.status === 'activo'">
                  Desactivar
                </template>
                <template v-else>
                  Activar
                </template>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="deleteItem(item.id, item.name)">
              <v-list-tile-title>Eliminar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </tr>
  </tbody>
</template>

<script>

import dataTableListMixin from '@/mixins/dataTableList';

export default {
  mixins: [
    dataTableListMixin,
  ],
  data() {
    return {
      showUrl: 'answer_templates',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/answer_template/AnswerTemplateList.vue